import { z } from 'zod';

export const AdditionalPropertiesIdSchema = z.enum([
    // Material
    'MANUAL_MATERIAL_V1',
    'AUTOMATIC_MATERIAL_V1',
    // Material waste
    'AUTOMATIC_WASTE_MATERIAL_V1',
    'MANUAL_WASTE_MATERIAL_V1',
    // Transport
    'MANUAL_TRANSPORT_V1',
    'MANUAL_TRANSPORT_V2',
    'AUTOMATIC_TRANSPORT_V1',
    // Transport waste
    'AUTOMATIC_NON_HAZARDOUS_WASTE_TRANSPORT_V1',
    'AUTOMATIC_HAZARDOUS_WASTE_TRANSPORT_V1',
    'MANUAL_WASTE_TRANSPORT_V1',
    // Service
    'MANUAL_SERVICE_V1',
    'AUTOMATIC_SERVICE_V1',
]);

export type AdditionalPropertiesId = z.infer<typeof AdditionalPropertiesIdSchema>;
